import React from 'react';
import styled from 'styled-components';

/* 
  NOTE: if you need to color any of the white sprites, start with filter: sepia(1) which will start you at 
  #B2A080 or hue:38deg, saturation(24.5%), brightness(60%), then you can start adjusting
*/

const GreenBGDiv = styled.div<any>`
  /* shift the yellow check icon ~#f3ab3c into a suitable green ~#006F0F
  by setting a hue-rotate to the delta between #f3ab3c converted to HSV
  then using the saturation and value(brightness) directly from #006F0F converted to HSV*/
  filter: hue-rotate(92deg) saturate(100%) brightness(43.5%);
  width: 32px;
  margin-left: calc((100% - 32px) / 2);
`;
const RedBGDiv = styled.div<any>`
  width: 32px;
  margin-left: calc((100% - 32px) / 2);
`;
const CenteredIconDiv = styled.div`
  filter: hue-rotate(2.9334rad) brightness(30%);
  margin-left: 6px;
  margin-top: 3px;
`;

export const GreenCheckMark = (
  <GreenBGDiv
    className="sprites sprite-assist-selected-32"
    alt="✓"
    description="Checkmark"
  ></GreenBGDiv>
);
export const RedXmark = (
  <RedBGDiv
    className="sprites sprite-cancelled-color-32"
    alt="✗"
    description="X Mark"
  ></RedBGDiv>
);

export const NewTabIcon = (
  <CenteredIconDiv className='sprites sprite-reopen-selected-16'></CenteredIconDiv>
);
